import { userTrainingGradeOptions } from 'configs/constants/user';

const trainingGrades = (formid, grade) => ({
  type: 'multiCheckbox',
  options: userTrainingGradeOptions(grade),
  inline: true,
});

export default trainingGrades;
